import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalContext } from "../Config";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

const CompletarInformacion = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idCliente = parseInt(searchParams.get("idCliente"));
  const idCotizacion = parseInt(searchParams.get("idCotizacion"));
  const desde = (searchParams.get("desde"));
  const hasta = (searchParams.get("hasta"));
  const navigate = useNavigate();

  const { baseUrl } = useGlobalContext();
  const [loading, setLoading] = useState(false);
  const [faltaInformacion, setFaltaInformacion] = useState([]);
  const [mensaje, setMensaje] = useState("");
  const [rutError, setRutError] = useState("");

  const [nuevoNombreContacto, setNuevoNombreContacto] = useState("");
  const [nuevoTipoContacto, setNuevoTipoContacto] = useState("");
  const [nuevoTelefonoContacto, setNuevoTelefonoContacto] = useState("");
  const [nuevoCorreoContacto, setNuevoCorreoContacto] = useState("");
  const [nuevoNombreRepresentante, setNuevoNombreRepresentante] = useState("");
  const [nuevoRutRepresentante, setNuevoRutRepresentante] = useState("");
  const [nuevoTelefonoRepresentante, setNuevoTelefonoRepresentante] =
    useState("");
  const [nuevoCorreoRepresentante, setNuevoCorreoRepresentante] = useState("");
  const [nuevaDireccion, setNuevaDireccion] = useState("");
  const [nuevoTipoDireccion, setNuevoTipoDireccion] = useState("");
  const [nuevoComuna, setNuevoComuna] = useState("");

  const buildCheckDatosFaltantesCliente = (idCliente) => {
    return `${baseUrl}getInformacionFaltanteByIdCliente?idCliente=${idCliente}`;
  };
  const tiposContacto = [
    { name: "COMERCIAL" },
    { name: "NATURAL" },
    { name: "OTRO" },
  ];
  const tiposDireccion = [
    { name: "COMERCIAL" },
    { name: "NATURAL" },
    { name: "OTRO" },
  ];

  useEffect(() => {
    checkDatosFaltantesCliente();
  }, [idCliente]);

  const checkDatosFaltantesCliente = async () => {
    try {
      setLoading(true);
      const response = await fetch(buildCheckDatosFaltantesCliente(idCliente));
      const data = await response.json();

      if (data?.mensaje === "No se encontró data faltante para el idCliente.") {
        setMensaje("El cliente tiene toda la información necesaria");

        if (idCliente && idCotizacion && desde && hasta) {
          const urlAVolver = `/revisarCotizacion?idCliente=${idCliente}&idCotizacion=${idCotizacion}&desde=${desde}&hasta=${hasta}`;
          navigate(urlAVolver);
        }
      } else {
        setFaltaInformacion(data?.faltaInformacion || []);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const cleanRut = (rut) => {
    return rut.replace(/^0+|[^0-9kK]+/g, "").toUpperCase();
  };

  const validateRut = (rut) => {
    if (!rut || typeof rut !== "string") return false;
    const cleanRutVal = cleanRut(rut);
    if (cleanRutVal.length < 2) return false;

    const body = cleanRutVal.slice(0, -1);
    const verifier = cleanRutVal.slice(-1);

    let sum = 0;
    let multiplier = 2;

    for (let i = body.length - 1; i >= 0; i--) {
      sum += multiplier * +body[i];
      multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }

    const mod = 11 - (sum % 11);
    const expectedVerifier =
      mod === 11 ? "0" : mod === 10 ? "K" : mod.toString();

    return expectedVerifier === verifier;
  };

  const formatRut = (rut) => {
    const cleanRutVal = cleanRut(rut);
    let result =
      cleanRutVal.slice(-4, -1) +
      "-" +
      cleanRutVal.substr(cleanRutVal.length - 1);

    for (let i = 4; i < cleanRutVal.length; i += 3) {
      result = cleanRutVal.slice(-3 - i, -i) + "." + result;
    }

    return result;
  };

  const handleRutChange = (e) => {
    const value = e.target.value;
    const cleanedValue = cleanRut(value);
    setNuevoRutRepresentante(cleanedValue);

    if (validateRut(cleanedValue)) {
      setRutError("");
      setNuevoRutRepresentante(formatRut(cleanedValue));
    } else {
      setRutError("RUT inválido");
    }
  };

  const shouldRenderContactos = (faltaInformacion) => {
    const fields = [
      "nombre_contacto",
      "tipo_contacto",
      "telefono_contacto",
      "correo_contacto",
    ];
    return fields.some((field) => faltaInformacion.includes(field));
  };

  const shouldRenderRepresentanteLegal = (faltaInformacion) => {
    const fields = [
      "rut_representante_legal",
      "nombre_representante_legal",
      "correo_representante_legal",
      "telefono_representante_legal",
    ];
    return fields.some((field) => faltaInformacion.includes(field));
  };

  const shouldRenderDireccion = (faltaInformacion) => {
    const fields = [
      "direccion_domicilio",
      "tipo_domicilio",
      "comuna_domicilio",
    ];
    return fields.some((field) => faltaInformacion.includes(field));
  };

  const handleSubmit = async () => {
    if (!validateRut(nuevoRutRepresentante) && nuevoRutRepresentante) {
      setRutError("RUT inválido");
      alert("RUT Representante inválido");
      return;
    } else {
      setRutError("");
    }

    const contactos = [
      {
        nombre: nuevoNombreContacto,
        tipo: nuevoTipoContacto?.name || "",
        telefono: nuevoTelefonoContacto,
        correo: nuevoCorreoContacto,
      },
    ];

    const domicilios = [
      {
        direccion: nuevaDireccion,
        tipo: nuevoTipoDireccion?.name || "",
        comuna: nuevoComuna,
      },
    ];

    const representantesLegales = [
      {
        nombre: nuevoNombreRepresentante,
        rut: nuevoRutRepresentante,
        telefono: nuevoTelefonoRepresentante,
        correo: nuevoCorreoRepresentante,
      },
    ];

    const isPartiallyFilled = (array) => {
      return (
        array.some((item) => Object.values(item).some((value) => value)) &&
        array.some((item) => Object.values(item).some((value) => !value))
      );
    };

    const isAllFieldsEmpty = (array) => {
      return array.every((item) =>
        Object.values(item).every((value) => !value)
      );
    };

    if (isPartiallyFilled(contactos)) {
      alert("Todos los campos de contacto deben estar llenos.");
      return;
    }

    if (isPartiallyFilled(domicilios)) {
      alert("Todos los campos de domicilio deben estar llenos.");
      return;
    }

    if (isPartiallyFilled(representantesLegales)) {
      alert("Todos los campos de representante legal deben estar llenos.");
      return;
    }

    if (
      isAllFieldsEmpty(contactos) &&
      isAllFieldsEmpty(domicilios) &&
      isAllFieldsEmpty(representantesLegales)
    ) {
      alert(
        "Todos los campos están vacíos. Por favor complete al menos un campo en cada sección."
      );
      return;
    }

    const filterEmptyFields = (array) => {
      return array.filter((item) => Object.values(item).some((value) => value));
    };

    const contactosToSend = filterEmptyFields(contactos);
    const domiciliosToSend = filterEmptyFields(domicilios);
    const representantesLegalesToSend = filterEmptyFields(
      representantesLegales
    );

    let url = `${baseUrl}actualizarCliente?idCliente=${idCliente}`;

    if (contactosToSend.length > 0) {
      url += `&contactos=${encodeURIComponent(
        JSON.stringify(contactosToSend)
      )}`;
    }

    if (domiciliosToSend.length > 0) {
      url += `&domicilios=${encodeURIComponent(
        JSON.stringify(domiciliosToSend)
      )}`;
    }

    if (representantesLegalesToSend.length > 0) {
      url += `&representantesLegales=${encodeURIComponent(
        JSON.stringify(representantesLegalesToSend)
      )}`;
    }

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (response.ok) {
        alert(data.mensaje);
      } else {
        alert(`Error: ${data.mensaje}`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error al actualizar la información del cliente");
    }
    window.location.reload();
  };

  return (
    <>
      <div className="card">
        {mensaje ? (
          <h5>{mensaje}</h5>
        ) : (
          <>
            <h5>Completar Información del Cliente</h5>
            <p>Por favor complete la información faltante para el cliente.</p>

            <div className="p-fluid formgrid grid">
              {shouldRenderContactos(faltaInformacion) && (
                <div className="field col-12">
                  <h5>Contacto</h5>
                  <div className="field col-12 md:col-12 mt-2">
                    <label style={{ marginRight: "10px" }}>Nombre</label>
                    <InputText
                      id="nombreContacto"
                      type="text"
                      value={nuevoNombreContacto}
                      onChange={(e) =>
                        setNuevoNombreContacto(e.target.value.toUpperCase())
                      }
                    />
                  </div>
                  <div className="field col-12 md:col-12 mt-2">
                    <label style={{ marginRight: "10px" }}>Tipo</label>
                    <Dropdown
                      id="tipoContacto"
                      value={nuevoTipoContacto}
                      onChange={(e) => setNuevoTipoContacto(e.value)}
                      options={tiposContacto}
                      optionLabel="name"
                      placeholder="Seleccione El Tipo De Contacto"
                    />
                  </div>
                  <div className="field col-12 md:col-12 mt-2">
                    <label style={{ marginRight: "10px" }}>Teléfono</label>
                    <InputText
                      id="telefonoContacto"
                      type="text"
                      value={nuevoTelefonoContacto}
                      onChange={(e) => setNuevoTelefonoContacto(e.target.value)}
                    />
                  </div>
                  <div className="field col-12 md:col-12 mt-2">
                    <label style={{ marginRight: "10px" }}>Correo</label>
                    <InputText
                      id="correoContacto"
                      type="text"
                      value={nuevoCorreoContacto}
                      onChange={(e) =>
                        setNuevoCorreoContacto(e.target.value.toUpperCase())
                      }
                    />
                  </div>
                </div>
              )}

              {shouldRenderRepresentanteLegal(faltaInformacion) && (
                <div className="field col-12">
                  <h5>Representante Legal</h5>
                  <div className="field col-12 md:col-3">
                    <label style={{ marginRight: "10px" }}>Nombre</label>
                    <InputText
                      id="nombreRepresentante"
                      type="text"
                      value={nuevoNombreRepresentante}
                      onChange={(e) =>
                        setNuevoNombreRepresentante(
                          e.target.value.toUpperCase()
                        )
                      }
                    />
                  </div>
                  <div className="field col-12 md:col-3">
                    <label style={{ marginRight: "10px" }}>RUT</label>
                    <InputText
                      id="rutRepresentante"
                      type="text"
                      value={nuevoRutRepresentante}
                      onChange={handleRutChange}
                    />
                    {rutError && (
                      <small style={{ color: "red" }}>{rutError}</small>
                    )}
                  </div>
                  <div className="field col-12 md:col-3">
                    <label style={{ marginRight: "10px" }}>Teléfono</label>
                    <InputText
                      id="telefonoRepresentante"
                      type="text"
                      value={nuevoTelefonoRepresentante}
                      onChange={(e) =>
                        setNuevoTelefonoRepresentante(e.target.value)
                      }
                    />
                  </div>
                  <div className="field col-12 md:col-3">
                    <label style={{ marginRight: "10px" }}>Correo</label>
                    <InputText
                      id="correoRepresentante"
                      type="text"
                      value={nuevoCorreoRepresentante}
                      onChange={(e) =>
                        setNuevoCorreoRepresentante(
                          e.target.value.toUpperCase()
                        )
                      }
                    />
                  </div>
                </div>
              )}

              {shouldRenderDireccion(faltaInformacion) && (
                <div className="field col-12">
                  <h5>Dirección</h5>
                  <div className="field col-12 md:col-12">
                    <label style={{ marginRight: "10px" }}>Dirección</label>
                    <InputText
                      id="direccion"
                      type="text"
                      value={nuevaDireccion}
                      onChange={(e) =>
                        setNuevaDireccion(e.target.value.toUpperCase())
                      }
                    />
                  </div>
                  <div className="field col-12 md:col-12">
                    <label style={{ marginRight: "10px" }}>Comuna</label>
                    <InputText
                      id="comuna"
                      type="text"
                      value={nuevoComuna}
                      onChange={(e) =>
                        setNuevoComuna(e.target.value.toUpperCase())
                      }
                    />
                  </div>
                  <div className="field col-12 md:col-12">
                    <label style={{ marginRight: "10px" }}>Tipo</label>
                    <Dropdown
                      id="tipoDireccion"
                      value={nuevoTipoDireccion}
                      onChange={(e) => setNuevoTipoDireccion(e.value)}
                      options={tiposDireccion}
                      optionLabel="name"
                      placeholder="Seleccione El Tipo De Dirección"
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="button-container">
              <Button
                label="Guardar Información"
                className="p-button-success mt-4"
                onClick={handleSubmit}
                raised
              />
            </div>
          </>
        )}
      </div>

      <style jsx>{`
        .button-container {
          display: flex;
          justify-content: center;
          margin-top: 20px;
        }
      `}</style>
    </>
  );
};

export default CompletarInformacion;
